import React from 'react';
import Context from '../../../../../../context';
import {CustomBadges, CustomButton2, CustomModal, ResponsiveView} from '../../../../../../components';
import Saderat from './../../../../../../../assets/images/saderat.png';
import Zarinpal from './../../../../../../../assets/images/zarinpal.png';
import api from '../../../../../../api';
import utils from '../../../../../../utils';

import './index.scss';
import payFinancialReportDrivers from "../../../../../../api/method.get/company/payFinancialReportDrivers";

type Props = {
  data: any;
}

const PayModal: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { request, reFetch } = React.useContext(Context.FactorsNeedPay2CompanyScreenContext);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function payHandler(): Promise<void> {
    setIsLoading(true);
    const result = await api.get.company.payFinancialReportDrivers(request);
    if (result) {
      utils.successHandler(Number(result.CODE));
      await reFetch();
      setIsOpen(false);
    }
    setIsLoading(false);
  }

  function handleOnClick(): void {setIsOpen(!isOpen)}

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id='pay-modal'>
      <CustomButton2 onClick={handleOnClick} title={'ساخت گذارش مالی'} type={'primary'} />
      <CustomModal open={isOpen} onClose={handleOnClick} overlayOpacity={'0.3'} minWidth={'20vw'} maxWidth={'30vw'}>
        <div className='price'>ساخت گزارش مالی شرکت</div>
        <ResponsiveView.Row>
          <ResponsiveView.Column medium={12} style={{padding: '1rem'}}>
            <CustomBadges title={`تعداد راننده ${props.data?.totalReports}`} />
          </ResponsiveView.Column>
          <ResponsiveView.Column medium={12} style={{padding: '1rem'}}>
            <CustomBadges title={`تعداد گزارشات مالی ${props.data?.totalReports}`} type={'primary'} />
          </ResponsiveView.Column>
          <ResponsiveView.Column medium={12} style={{padding: '1rem'}}>
            <CustomBadges title={`سهم شرکت : ${props.data?.totalShareCompany.toLocaleString()}`} type={'secondary'} />
          </ResponsiveView.Column>
        </ResponsiveView.Row>
        <CustomButton2 title={'پرداخت'} onClick={payHandler} isLoading={isLoading}/>
      </CustomModal>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default PayModal;
